import React from 'react'
import PropTypes from 'prop-types'
import { Highlighter } from '../../../../components'
import { Content1, Content2, Content3, MediaWrapper } from './style'

const ContentSection1 = ({ data }) => {
  const formatDate2 = (param) => {
    const dd = new Date(param)
    const hours = dd.getHours()
    const ampm = hours >= 12 ? 'PM' : 'AM'
    return `${dd.getMonth() + 1}/${dd.getDate()}/${dd.getFullYear()} ${hours}:${dd.getMinutes()}:${dd.getSeconds()} ${ampm}`
  }

  const GetByDetails = () => {
    const userUrl = data?.AggregationItem?.ItemUser?.UserProfileUrl
    const userName = data?.AggregationItem?.ItemUser?.UserName
    if (userUrl === '' && userName.indexOf('http') !== -1) {
      return (<>By <a href={userName} target='_blank' rel='noreferrer'>{userName}</a><br /></>)
    } else if (userUrl.indexOf('http') !== -1) {
      return (<>By <a href={userUrl} target='_blank' rel='noreferrer'>{userName}</a><br /></>)
    } else {
      return (<>By {userName}<br /></>)
    }
  }

  return (
    <>
      <Content1>
        {data.AggregationItem.ItemTitle}<br /><br />{data.AggregationItem.ItemType}
      </Content1>

      <Content2>
        {data?.AggregationItem?.ItemUser?.UserName && <GetByDetails />}
        On <a href={data.AggregationItem.ItemUrl} target='_blank' rel='noreferrer'>{formatDate2(data.AggregationItem.ItemDateTime)}</a>
      </Content2>

      {data.AggregationItem.ItemSource.SourceName === 'Forums___' && <MediaWrapper>
        This is Forum
      </MediaWrapper>}

      {data.AggregationItem.ItemSource.SourceName === 'Instagram___' && <MediaWrapper>
        This is Instagram
      </MediaWrapper>}

      {data.AggregationItem.ItemSource.SourceName === 'YouTubeVideo' && <MediaWrapper>
        <iframe id="iframeYouTubeVideo" type="text/html" width="266" height="225" src={(data.AggregationItem.ItemUrl).replace('watch?v=', 'embed/').replace('http:', 'https:')} allowfullscreen=""></iframe>
      </MediaWrapper>}

      {/* <Content3>{formatDate1(data.AggregationItem.ModifiedDate)} ... {data.AggregationItem.CoreItem}</Content3> */}
      {/* <Content3 dangerouslySetInnerHTML={{ __html: decodeURIComponent(data.AggregationItem.CoreItem) }}></Content3> */}
      {/* <Content3>{consoleLog(data.AggregationItem.CoreItem)}</Content3> */}
      {/* <Content3>{decodeURIComponent(data.AggregationItem.CoreItem)}</Content3> */}

      {/* <PriorityButton type={data.AggregationItem.InfluenceLevel} sourceName={data.AggregationItem.ItemSource.SourceName} /> */}

      <Content3>
        {/* {data.AggregationItem.CoreItem} */}
        {/*
        <MuiTextField
          name='CoreItem'
          variant='standard'
          // value={decodeURIComponent(data.AggregationItem.CoreItem) || ''}
          value={(data.AggregationItem.CoreItem) || ''}
          disabled={true}
          multiline
        />
        */}
        <pre style={{ textWrap: 'auto' }}>
          <Highlighter text={data.AggregationItem.CoreItem} />
        </pre>
      </Content3>
    </>
  )
}

ContentSection1.propTypes = {
  data: PropTypes.object
}

export default ContentSection1
